import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { grey, unityGrey } from './colors';

export const text = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['text'] => {
  const accent = grey[300];
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          primary: unityGrey[950],
          secondary: unityGrey[600],
          disabled: unityGrey[300],
          inversePrimary: unityGrey[50],
          inverseSecondary: unityGrey[200],
          navigationHeader: unityGrey[200],
          accent: unityGrey[300],
        }
      : {
          primary: unityGrey[50],
          secondary: unityGrey[200],
          disabled: unityGrey[500],
          inversePrimary: unityGrey[950],
          inverseSecondary: unityGrey[600],
          navigationHeader: unityGrey[200],
          accent: unityGrey[300],
        };
  }

  return mode === 'light'
    ? {
        primary: grey[950],
        secondary: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        inverseSecondary: grey[200],
        navigationHeader: grey[200],
        accent,
      }
    : {
        primary: grey[50],
        secondary: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        inverseSecondary: grey[600],
        navigationHeader: grey[200],
        accent,
      };
};
